<template>
  <v-app>
    <RootLayout class="height-100" />

    <!-- TODO 임의 배치 (article height 100%에 영향주지 않게 하려다보니) -->
    <NewFooter v-if="hasFooter" />

    <!-- production 상태일때는 안나오게 수정 -->
    <Errors v-if="mode !== 'production'" />
  </v-app>
</template>
<script>
import RootLayout from '@/layouts/RootLayout'
import Errors from '@/components/error/FooterErrors'
import { mapGetters, mapState } from 'vuex'

export default {
  metaInfo() {
    return this.metaInfo
  },
  name: 'App',
  components: {
    RootLayout,
    Errors,

    NewFooter: () => import('@/components/common/layout/NewFooter.vue'),
  },
  computed: {
    ...mapState('env', ['mode']),
    ...mapState('meta', { getMeta: 'meta' }),
    ...mapGetters('myfinbiz', ['faviconUrl']),

    hasFooter() {
      return this.$route.meta?.ui?.footer
    },
  },
  watch: {
    getMeta(value) {
      this.metaInfo = value
      this.$meta().refresh()
    },
    faviconUrl: {
      immediate: true,
      handler(newUrl) {
        const favicon = document.getElementById('favicon');
        if (favicon) {
          favicon.href = newUrl;
        }
        console.log('새로운 파비콘 ', newUrl);
      },
    },
  },
  data() {
    return {
      metaInfo: {},
    }
  },
}
</script>
